import React from "react";
import { ButtonWithLoader } from "@design-system/Button/ButtonWithLoader";
import styles from "./SettingRow.module.scss";

interface SettingRowProps {
    label: string;
    value?: React.ReactNode | null;
    buttonText?: string;
    onButtonClick?: () => void;
    renderButton?: () => React.ReactNode;
    isLoading?: boolean;
}

export const SettingRow: React.FC<SettingRowProps> = ({
    label,
    value,
    buttonText,
    onButtonClick,
    isLoading,
    renderButton,
}) => (
    <div className={styles.settingRow}>
        <div className={styles.data}>
            <span className={styles.label}>{label}</span>
            <span className={styles.value}>{value ?? ""}</span>
        </div>
        {renderButton && renderButton()}
        {onButtonClick && (
            <ButtonWithLoader
                variant="primary"
                size="md"
                loading={isLoading ?? false}
                onClick={onButtonClick}
            >
                {buttonText}
            </ButtonWithLoader>
        )}
    </div>
);
